/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: NoRecipesCallout.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/14 @ 1522
 * ---
 * Description:
 */

import {Callout, Icon, Intent} from '@blueprintjs/core';

interface Props {
  orgName: string;
  className?: string;
}

export const NoRevisionCallout = (props: Props) => {
    return (
        <Callout title="Nessuna revisione trovata" className={props.className}
                 intent={Intent.WARNING}
                 icon={<Icon icon="inbox" size={20}/>}>
            <div className="bp4-text-muted">
                Non è stato possibile trovare alcuna revisione
                nell'organizzazione '{props.orgName}'. Crea una nuova revisione per
                utilizzarla con MyLabel
            </div>
        </Callout>
  );
};